import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import HomePage from "./components/ecostyle/pages/HomePage/HomePage";
import LowPowerPage from "./components/ecostyle/pages/LowPowerPage/LowPowerPage";
import LowPowerWithoutFactorPage from "./components/ecostyle/pages/LowPowerPage/LowPowerWithoutFactorPage";

const lowPowerPlanWithoutFactorDate =
  process.env.REACT_APP_LOW_POWER_PLAN_WITHOUT_FACTOR_DATE;

const isEnableLowPowerPlanWithoutFactor =
  new Date() >= new Date(lowPowerPlanWithoutFactorDate!);

ReactDOM.render(
  <Router>
    <Switch>
      <Route exact path="/" component={HomePage} />
      {!isEnableLowPowerPlanWithoutFactor && (
        <Route path="/power" component={LowPowerPage} />
      )}
      {isEnableLowPowerPlanWithoutFactor && (
        <Route path="/power" component={LowPowerWithoutFactorPage} />
      )}
    </Switch>
  </Router>,
  document.getElementById("root")
);
